import React from 'react'
import clsx from 'clsx'

import { Field, FieldProps, Label, LabelProps } from '@makyoapp/makyo-ui'

/**
 * common label
 */
export function Lbl(props: LabelProps) {
  return <Label {...props} defaultSize={false} className={clsx('lbl-sm', props.className)} />
}

/**
 * common field wrapper for form field
 */
export function Fld(props: FieldProps) {
  return (
    <Field
      {...props}
      defaultSize={false}
      noPad
      className={clsx(props.defaultSize !== false && 'min-h-[3rem]', props.className)}
    />
  )
}
